'use strict';

import {reverseUrl} from 'utils/django';


export default function() {
	return reverseUrl;
}
